const moment = require('moment');

export default function formatDate(value: any, formatString: string) {
    return moment(value).format(formatString ? formatString : 'DD-MM-YYYY hh:mm:ss');
}
